export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // Usar favicon YESZAP com badge
    const newFileName = `/favicon-badge.svg`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        // Voltar para favicon YESZAP padrão
        favicon.href = '/favicon.ico';
      });
    }
  });
};
